import Vue from 'vue'
import App from './App'
import router from './router'
// echarts可视化
// import * as echarts from 'echarts'
// 导入api接口
import api from './utils/api.js'
// 导航栏加载条
import NProgress from 'nprogress'

// 按需引入element
import { Header,Main,Footer,Row,Col,Carousel,CarouselItem,Form,FormItem,Button,Input,Select,Option,Checkbox,CheckboxGroup,RadioGroup,Radio,RadioButton,Table,TableColumn,Pagination,DatePicker,Image,Dialog,Tooltip,Popover,Divider,Drawer,Message,MessageBox,Loading,InfiniteScroll,Collapse,CollapseItem,Calendar } from 'element-ui'

// 注册框架
Vue.use(Header)
Vue.use(Main)
Vue.use(Footer)
Vue.use(Row)
Vue.use(Col)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Button)
Vue.use(Input)
Vue.use(Select)
Vue.use(Option)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(RadioButton)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)
Vue.use(DatePicker)
Vue.use(Image)
Vue.use(Dialog)
Vue.use(Tooltip)
Vue.use(Popover)
Vue.use(Divider)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Calendar)

Message.install = function (Vue, options) {
    Vue.prototype.$message = Message
    Vue.prototype.$confirm = MessageBox.confirm
}
Vue.use(Drawer)
Vue.use(Message)
Vue.use(Loading)
Vue.use(InfiniteScroll)

Vue.config.productionTip = false

// Vue.prototype.$echarts = echarts
// 将api挂载到vue的原型上
Vue.prototype.$api = api
// 引入过滤器
import filters from './filters';
Object.keys(filters).forEach(k => Vue.filter(k, filters[k]));

// 引入Element资源
// import './assets/element-ui/index.css'
import './assets/element-ui/header.css'
import './assets/element-ui/main.css'
import './assets/element-ui/footer.css'
import './assets/element-ui/row.css'
import './assets/element-ui/col.css'
import './assets/element-ui/icon.css'
import './assets/element-ui/carousel.css'
import './assets/element-ui/carousel-item.css'
import './assets/element-ui/form.css'
import './assets/element-ui/form-item.css'
import './assets/element-ui/button.css'
import './assets/element-ui/input.css'
import './assets/element-ui/select.css'
import './assets/element-ui/option.css'
import './assets/element-ui/checkbox.css'
import './assets/element-ui/checkbox-group.css'
import './assets/element-ui/radio-group.css'
import './assets/element-ui/radio.css'
import './assets/element-ui/radio-button.css'
import './assets/element-ui/table.css'
import './assets/element-ui/table-column.css'
import './assets/element-ui/pagination.css'
import './assets/element-ui/date-picker.css'
import './assets/element-ui/image.css'
import './assets/element-ui/dialog.css'
import './assets/element-ui/drawer.css'
import './assets/element-ui/message.css'
import './assets/element-ui/message-box.css'
import './assets/element-ui/tooltip.css'
import './assets/element-ui/popover.css'
import './assets/element-ui/divider.css'
import './assets/element-ui/loading.css'
import './assets/element-ui/collapse.css'
import './assets/element-ui/calendar.css'

// 引入导航栏加载条资源
import './assets/nprogress/nprogress.css'

// 引入mavonEditor文档
import mavonEditor from 'mavon-editor'
Vue.use(mavonEditor)
import 'mavon-editor/dist/css/index.css'

// 引入iconfont
import "./assets/iconfont/iconfont.css"

// 引入meta-info
import metaInfo from 'vue-meta-info'
Vue.use(metaInfo)

// 引入省略号弹窗组件
import Ellipsis from 'vue-directive-ellipsis';
import './assets/vue-directive-ellipsis/ellipsis.umd.css';
Vue.directive('ellipsis', Ellipsis);
// 注册为组件
// Vue.component('ellipsis', Ellipsis)

// 路由拦截
router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        // 流量分析、讲品表、商品列表除外
        if (to.name !== "flowAnalysis" && to.name !== "lectureAnalysis" && to.name !== "commodity") {
            document.title = to.meta.title
        }
    }
    NProgress.start()
    next();
})

router.afterEach(() => {
    NProgress.done()
})

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js